import * as React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import logo from "../img/teamspective-logo-regular-inverted.svg"
import CreateAccountForm from "./CreateAccountForm"
import gdprLogo from "../img/GDPR-logo.png"
import soc2Logo from "../img/SOC2-logo.png"
import ccpaLogo from "../img/CCPA-logo.png"

const Footer = ({ navigationItems }) => {
  const {
    markdownRemark: {
      frontmatter: {
        footer: { cta, companyDescription },
      },
    },
  } = useStaticQuery(graphql`
    query FooterQuery {
      markdownRemark(frontmatter: { id: { eq: "common" } }) {
        frontmatter {
          footer {
            cta {
              title
              description
            }
            companyDescription
          }
        }
      }
    }
  `)
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-cta">
          <h2>{cta.title}</h2>
          <p className="description">{cta.description}</p>
          <CreateAccountForm />
        </div>
        <div className="footer-info">
          <div className="footer-logo">
            <img className="logo" alt="Teamspective" width={200} src={logo} />
            {navigationItems.map(({ title, path }) => (
              <Link className="navbar-item" to={path} key={path}>
                {title}
              </Link>
            ))}
          </div>
          <div className="footer-description">
            <p>{companyDescription}</p>
          </div>
          <div className="footer-security">
            <div>Your data is safe with Teamspective</div>
            <div>
              Read more in our{" "}
              <a
                style={{ color: "white", textDecoration: "underline" }}
                href={"https://trust.teamspective.com"}
              >
                Trust Center
              </a>
            </div>
            <div className="security-banner-logos spacing-m">
              <img alt="GDPR" src={gdprLogo} />
              <img alt="SOC 2" src={soc2Logo} />
              <img alt="CCPA" src={ccpaLogo} />
            </div>
            <a
              style={{
                color: "white",

                marginRight: 16,
              }}
              href="https://teamspectivestatus.com/"
            >
              Service status
            </a>{" "}
            <Link
              style={{
                color: "white",

                marginRight: 16,
              }}
              to="/privacy-policy/"
            >
              Privacy policy
            </Link>{" "}
            <Link style={{ color: "white" }} to="/terms-of-service/">
              Terms of service
            </Link>
          </div>
        </div>
        <div className="footer-bottom">
          &copy; 2025 Teamspective. All Rights Reserved
        </div>
      </div>
    </footer>
  )
}

export default Footer
